import { useRef, useEffect } from 'react';


export default function Canvas({ image }) {
  const canvasRef = useRef();
  

  useEffect(() => {
    if (!image) return;
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');
    const img = new Image();
    img.src = image;
    img.onload = () => {
      canvas.width = img.width;
      canvas.height = img.height;
      ctx.drawImage(img, 0, 0);
    };
  }, [image]); // nếu muốn rerender khi tool thay đổi

  return <canvas ref={canvasRef} className="border border-gray-300" />;
}
